import React from 'react';
import { AppService, AppConfig } from '@aperza/util';
const appConfig = AppService.appConfig();
export default class Notification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
        };
    }
    onClickClose() {
        this.setState({
            show: false,
        });
    }
    render() {
        // let shouldShow = !appConfig.isAperzaCatalog && appConfig.serviceType!=AppConfig.APERZA_NEWS;
        //let shouldShow = appConfig.isAperzaCatalog || appConfig.isAperzaCatalogTop;
        let shouldShow = [
            AppConfig.APERZA_SEARCH,
            AppConfig.APERZA_ID,
            AppConfig.APERZA_ACCOUNT,
            AppConfig.APERZA_EC,
            AppConfig.APERZA_ORDER,
        ].includes(appConfig.serviceType);
        let style = { display: 'none' };
        if (this.state.show && shouldShow) {
            style = {};
        }
        return null; // disable notifications
        // <div className="notification" style={style}>
        //   <ul style={{listStyle: 'none', padding: 0}}>
        //     <li>年末年始休業期間のご案内[12/28（土）～1/5（日）]　≫<a href={'https://www.aperza.com/corp/20191223'} target="_blank">詳細はこちら</a></li>
        //   </ul>
        // </div>
    }
}
